import request from './request';




//-----------------下载及其他列表
export function getResources(data) {
    return request({
        url: `file/lists?cid=${data.cid}`,
        method: 'get',
    })
}

//-----------------下载及其他分类
export function getlistCate(data) {
    return request({
        url: `file/listCate`,
        method: 'get',
    })
}


//---------------联系人列表
export function contactsLists(data) {
    return request({
        url: `Contacts/lists?${data}`,
        method: 'get',
    })
}


// //---------------企业详情
// export function companyInfo() {
//     return request({
//         url: 'Company/detail',
//         method: 'get',
//     })
// }

// 新增联系人
export function addContacts(data) {
    return request({
        url: 'Contacts/add',
        method: 'post',
        data
    })
}

// 编辑联系人
export function editContacts(data) {
    return request({
        url: 'Contacts/edit',
        method: 'put',
        data
    })
}

//-----------------联系人详情
export function getContactsDetail(data) {
    return request({
        url: `Contacts/detail?contacts_long_id=${data.contacts_long_id}`,
        method: 'get',
    })
}


//---------------获取企业招聘列表
export function recruitList(data) {
    return request({
        url: `company_recruit/lists?${data}`,
        method: 'get',
    })
}

// 新增企业招聘
export function addRecruit(data) {
    return request({
        url: 'company_recruit/add',
        method: 'post',
        data
    })
}

// 编辑企业招聘
export function editRecruit(data) {
    return request({
        url: 'company_recruit/edit',
        method: 'put',
        data
    })
}

// 删除企业招聘
export function delRecruit(data) {
    return request({
        url: 'company_recruit/delete',
        method: 'delete',
        data
    })
}


//---------------获取胸卡列表
export function badgeList(data) {
    return request({
        url: `company_badge/lists?${data}`,
        method: 'get',
    })
}

// 新增胸卡
export function addBadge(data) {
    return request({
        url: 'company_badge/add',
        method: 'post',
        data
    })
}

// 编辑胸卡
export function editBadge(data) {
    return request({
        url: 'company_badge/edit',
        method: 'put',
        data
    })
}

// 删除胸卡
export function delBadge(data) {
    return request({
        url: 'company_badge/delete',
        method: 'delete',
        data
    })
}


// 获取国家区号
export function getPhoneCode(data) {
    return request({
        url: `company/getPhoneCode?${data}`,
        method: 'get',
    })
}

export function productTypelist() {
    return request({
        url: `ProductType/lists`,
        method: 'get',
    })
}

//---------------获取产品列表
export function productList(data) {
    return request({
        url: `product/lists?${data}`,
        method: 'get',
    })
}

//---------------产品信息详情
export function productDetails(data) {
    return request({
        url: `product/detail?${data}`,
        method: 'get',
    })
}

// 增加产品
export function addproduct(data) {
    return request({
        url: 'product/add',
        method: 'post',
        data
    })
}

// 编辑产品
export function editproduct(data) {
    return request({
        url: 'product/edit',
        method: 'put',
        data
    })
}


// 删除产品
export function delproduct(data) {
    return request({
        url: 'product/delete',
        method: 'delete',
        data
    })
}


// 编辑企业楣版字
export function editCompany(data) {
    return request({
        url: 'Company/edit',
        method: 'put',
        data
    })
}

//---------------企业楣版字详情
export function companyDetails(data) {
    return request({
        url: `Company/detail?${data}`,
        method: 'get',
    })
}

//---------------发票列表
export function invoiceList(data) {
    return request({
        url: `Invoice/lists?${data}`,
        method: 'get',
    })
}

// 添加发票
export function addInvoice(data) {
    return request({
        url: 'Invoice/add',
        method: 'post',
        data
    })
}

// 编辑发票
export function editInvoice(data) {
    return request({
        url: 'Invoice/edit',
        method: 'put',
        data
    })
}

//---------------发票详情
export function invoiceDetails(data) {
    return request({
        url: `Invoice/detail?invoice_long_id=${data.invoice_long_id}`,
        method: 'get',
    })
}

//企业营业执照和产品知识产权
export function editPic(data) {
    return request({
        url: 'Company/editPic',
        method: 'put',
        data
    })
}


// 邀请函背景图添加
export function addbackground(data) {
    return request({
        url: 'invitation_background/add',
        method: 'post',
        data
    })
}

// 邀请函背景图删除
export function delbackground(data) {
    return request({
        url: 'invitation_background/delete',
        method: 'delete',
        data
    })
}

// 邀请函背景图列表
export function backgroundList() {
    return request({
        url: `invitation_background/lists`,
        method: 'get',
    })
}

// 生成邀请函
export function addinvitation(data) {
    return request({
        url: 'invitation/add',
        method: 'post',
        data
    })
}

// 生成邀请函列表
export function invitationList() {
    return request({
        url: `invitation/lists`,
        method: 'get',
    })
}

// 邀请函背景图删除
export function delinvitation(data) {
    return request({
        url: 'invitation/delete',
        method: 'delete',
        data
    })
}

// 删除联系人
export function delContacts(data) {
    return request({
        url: 'Contacts/delete',
        method: 'delete',
        data
    })
}

// 展商菜单获取富文本
export function companyMenuDetail(data) {
    return request({
        url: `CompanyMenu/detail?id=${data.id}`,
        method: 'get',
    })
}





//------------------基本配置 左侧菜单详情
export function getDetail(data) {
    return request({
        url: `exhibitor/menu/detail?detail_id=${data}`,
        method: 'get',
    })
}



//---------------基础信息
export function sessionInfo() {
    return request({
        url: 'exhibitor/accessibility/session',
        method: 'get',
    })
}




//---------------产品信息 添加、编辑、删除
export function productHandle(method, data) {
    return request({
        url: 'exhibitor/product/one',
        method,
        data,
    })
}


//---------------邀请用户列表
export function userRegister(data) {
    return request({
        url: `exhibitor/company/userregister?${data}`,
        method: 'get',
    })
}

//---------------展商企业类型
export function companyType() {
    return request({
        url: 'exhibitor/company/ctype',
        method: 'GET',
    })
}



//---------------保存草稿
export function draft(data) {
    return request({
        url: 'exhibitor/company/draft',
        method: 'PUT',
        data,
    })
}

//---------------提交审核
export function submitCompanyInfo(data) {
    return request({
        url: 'exhibitor/company/info',
        method: 'PUT',
        data,
    })
}

//--------------保存责任书
export function saveResponsibility(data) {
    return request({
        url: 'exhibitor/company/responsibility',
        method: 'post',
        data,
    })
}

//---------------获取责任书
export function getResponsibility() {
    return request({
        url: 'exhibitor/company/responsibility',
        method: 'get',
    })
}

//-------------获取动态小程序码
export function getCode(data) {
    return request({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "APIVER": "v4.0",
        },
        responseType: 'base64',
        method: 'get',
        url: `exhibitor/company/getCode?${data}`,
    })
}

//-------------获取报道通知
export function getNotice() {
    return request({
        url: 'exhibitor/company/invitation',
        method: 'get',
        responseType: 'blob',
    })
}

//--------------下载记录
export function download(data) {
    return request({
        url: 'exhibitor/menu/download',
        method: 'post',
        data,
    })
}

//-------------自定义邀请函背景
export function setBackground(method, data) {
    return request({
        url: 'exhibitor/company/background',
        method,
        data
    })
}

//-------------已制作的邀请函背
export function makeBackground(method, data) {
    return request({
        url: 'exhibitor/company/invitation_image',
        method,
        data
    })
}

//---------------获取展商筛选项
export function optionList() {
    return request({
        url: 'exhibitor/company/optionList',
        method: 'get',
    })
}



//-------------------申报注册 赵 2025年2月18日14:15:21
export function register(data) {
    return request({
        url: 'declare/login/register',
        method: 'post',
        data
    })
}

//-------------------登录 赵 2025年2月18日16:06:31
export function SignInaccount(data) {
    return request({
        url: 'declare/login/account',
        method: 'post',
        data
    })
}

//-------------------基本配置 菜单 赵 2025年2月18日16:13:15
export function getmyMenu(data) {
    return request({
        url: `declare/defaultMenu/lists?${data}`,
        method: 'get',
    })
}
//-------------------申报届次 赵 2025年2月18日16:13:15
export function declareItems_lists(data) {
    return request({
        url: `declare/declareItems/lists?${data}`,
        method: 'get',
    })
}//-------------------下载中心 赵 2025年2月18日16:13:15
export function files_lists(data) {
    return request({
        url: `declare/files/lists?${data}`,
        method: 'get',
    })
}



//---------------获取场地  赵
export function siteLists(data) {
    return request({
        url: `declare/declareItems/siteLists?${data}`,
        method: 'get',
    })
}



//------------------账号密码登出 赵 2025年2月18日17:53:03
export function logOut() {
    return request({
        url: 'declare/login/logout',
        method: 'post',
    })
}


// 保存品牌方邮寄信息
export function saveMail(data) {
    return request({
        url: `declare/declareOrder/saveMail`,
        method: 'post',
        data
    })
}
// 保存品牌方快递单号
export function saveDeliveryNo(data) {
    return request({
        url: `declare/declareOrder/saveDeliveryNo`,
        method: 'post',
        data
    })
}


// 选场意愿提交  赵 2025年2月21日21:51:38
export function declareOrder_add(data) {
    return request({
        url: `declare/declareOrder/add`,
        method: 'post',
        data

    })
}
// 合同确认下一步  赵 2025年2月25日16:46:34
export function orderConfirm(data) {
    return request({
        url: `declare/declareOrder/orderConfirm`,
        method: 'post',
        data

    })
}


//提交汇款
export function swiftSubmit(data) {
    return request({
        url: `declare/fashionBrand/swiftSubmit`,
        method: 'post',
        data
    })
}

//尾款提交 2025年2月24日18:48:22 赵
export function finalPaymentVoucher(data) {
    return request({
        url: `declare/declareOrder/finalPaymentVoucher`,
        method: 'post',
        data
    })
}
//获取定金详情
export function declareOrder_detail(data) {
    return request({
        url: `declare/declareOrder/detail?${data}`,
        method: 'get',
    })
}


//------------------获取验证码
export function getVerify() {
    return request({
        url: 'declare/login/captcha',
        method: 'get',
    })
}

//------------------获取手机验证码 申报
export function Login_sendCode(data) {
    return request({
        url: `declare/login/sendCode`,
        method: 'post',
        data
    })
}
//------------------修改密码忘记密码 赵 2025年2月18日17:13:48
export function Login_forgotPasswd(data) {
    return request({
        url: `declare/login/forgotPasswd`,
        method: 'put',
        data
    })
}

// 下单
export function placeAnorder(data) {
    return request({
        url: `communal/UnifiedOrder/placeOrder`,
        method: 'post',
        data
    })
}
// 获取支付方式
export function getPaymentMethod(data) {
    return request({
        url: `communal/PayWay/getPayWay?${data}`,
        method: 'get',
        data
    })
}
// 获取订单支付状态
export function getUnifiedOrderPayStatus(data) {
    return request({
        url: `communal/UnifiedOrder/payStatus?${data}`,
        method: 'get',
        data
    })
}
// 预支付订单
export function setPrePaidOrder(data) {
    return request({
        url: `communal/UnifiedOrder/prePay`,
        method: 'post',
        data
    })
}
// 获取对公转账信息
export function getCorporateTransferInfo(data) {
    return request({
        url: `communal/PayWay/getBankInfo?${data}`,
        method: 'get',
    })
}


// 申报系统 李晨
// 获取省市
export function getProvinceAndCity() {
    return request({
        url: `declare/locations/getLocationTree`,
        method: 'get'
    })
}
// 获取数据字典
export function getDictionary(data) {
    return request({
        url: `declare/config/dict${data}`,
        method: 'get'
    })
}
// 获取奖项（秀和展）
export function getAwards() {
    return request({
        url: `declare/brandAwards/lists`,
        method: 'get'
    })
}
// 获取资料审核数据(回显)
export function getDataReview(data) {
    return request({
        url: `declare/fashionBrand/detail?${data}`,
        method: 'get',
    })
}
// 资料审核保存
export function saveDataReview(data) {
    return request({
        url: `declare/fashionBrand/save`,
        method: 'post',
        data
    })
}
// 资料审核提交
export function submitDataReview(data) {
    return request({
        url: `declare/fashionBrand/submit`,
        method: 'post',
        data
    })
}
// 获取步骤进度
export function getStepAndState(data) {
    return request({
        url: `declare/fashionBrand/getProgess?${data}`,
        method: 'get'
    })
}

// 票务系统 李晨
// 获取活动列表
export function getActivityList(data) {
    return request({
        url: `declare/fashion_activities/lists?${data}`,
        method: 'get'
    })
}
// 获取活动详情
export function getActivityDetail(data) {
    return request({
        url: `declare/fashion_activities/detail?${data}`,
        method: 'get'
    })
}
// 修改活动
export function modifyActivityDetail(data) {
    return request({
        url: `declare/fashion_activities/edit`, 
        method: 'put',
        data,
    })
}
// 获取邀请函列表
export function getInvitationList(data) {
    return request({
        url: `declare/fashion_invitation/lists?${data}`,
        method: 'get',
    })
}
// 批量生成邀请函
export function batchGenerationInvitation(data) {
    return request({
        url: `declare/fashion_invitation/batchAdd`,
        method: 'post',
        data
    })
}
// 下载小程序码
export function downloadQrcode(data) {
    return request({
        url: `declare/fashionActivities/downloadQrcode?${data}`,
        method: 'get',
    })
}

// 获取邀请函详情
export function getInvitationDetail(data) {
    return request({
        url: `declare/fashion_invitation/detail?${data}`,
        method: 'get'
    })
}
// 修改邀请函
export function modifyInvitationContent(data) {
    return request({
        url: `declare/fashion_invitation/edit`,
        method: 'put',
        data
    })
}
// 删除邀请函
export function deleteInvitation(data) {
    return request({
        url: `declare/fashion_invitation/delete`,
        method: 'delete',
        data
    })
}
// 获取上一次传入的邀请函底图
export function getLastTimeCoverImage(data) {
    return request({
        url: `declare/fashion_invitation/getLastCoverImage?${data}`,
        method: 'get',
    })
}
// 获取报名人员列表
export function getRegistrationPersonnel(data) {
    return request({
        url: `declare/fashion_activites_enroll/lists?${data}`,
        method: 'get',
    })
}
// 获取报名人员信息详情
export function getRegistrationPersonnelDetail(data) {
    return request({
        url: `declare/fashion_activites_enroll/detail?${data}`,
        method: 'get'
    })
}
// 编辑报名人员信息详情
export function editRegistrationPersonnelDetail(data) {
    return request({
        url: `declare/fashion_activites_enroll/edit`,
        method: 'put',
        data
    })
}
// 删除报名人员信息
export function deleteRegistrationPersonnel(data) {
    return request({
        url: `declare/fashion_activites_enroll/delete`,
        method: 'delete',
        data
    })
}
// 审核报名人员信息
export function examineRegistrationPersonnel(data) {
    return request({
        url: `declare/fashion_activites_enroll/review`,
        method: 'put',
        data
    })
}
// 批量通过报名人员信息
export function batchApproveRegistrationPersonnel(data) {
    return request({
        url: `declare/fashion_activites_enroll/batchApprove`,
        method: 'put',
        data
    })
}
// 其他活动申报保存
export function saveOtherActivityDeclaration(data) {
    return request({
        url: `declare/fashionBrand/saveDeclare`,
        method: 'post',
        data
    })
}
// 获取其他活动申报详情
export function getOtherActivityDeclarationResult() {
    return request({
        url: `declare/fashionBrand/DeclareInfo`,
        method: 'get'
    })
}

// 纸质证件申报
// 获取证件列表
export function getPaperCertificateList(data) {
    return request({
        url: `declare/paper_ticket/lists?${data}`,
        method: 'get'
    })
}
// 新增纸质票
export function addPaperCertificate(data) {
    return request({
        url: `declare/paper_ticket/add`,
        method: 'post',
        data
    })
}
// 编辑纸质票
export function editPaperCertificate(data) {
    return request({
        url: `declare/paper_ticket/edit`,
        method: 'put',
        data
    })
}
// 删除纸质票
export function deletePaperCertificate(data) {
    return request({
        url: `declare/paper_ticket/delete`,
        method: 'delete',
        data
    })
}
// 获取纸质票详情
export function getPaperCertificateDetail(data) {
    return request({
        url: `declare/paper_ticket/detail?${data}`,
        method: 'get'
    })
}



